import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=f2389e4a&scoped=true&"
import script from "./Checkout.vue?vue&type=script&lang=js&"
export * from "./Checkout.vue?vue&type=script&lang=js&"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=f2389e4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2389e4a",
  null
  
)

export default component.exports